import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Button, Icon, Popup, Segment, Container} from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import "./TokenContainer.css";

export const NewTokenContainer = (
    newToken,
) => {
    
    const { t } = useTranslation();
    const tokenValue = !_.isNil(newToken.newToken)  ? newToken.newToken: null
    const copyToken = () => {
            if (tokenValue !== null){
            navigator.clipboard.writeText(tokenValue)
        }
    }
    return (
        <div >
            <Segment className="token-container" clearing  content={tokenValue}>
                <div>
                <Container className="token-container" textAlign='left'>
                    {_.isNil(tokenValue) ? '' : <div>{tokenValue}</div>}
                <Popup content={t("account.adminConsole.clickCopy")} trigger={
                    <Button floated="right"
                        className={"copy-token-button"}
                        disabled={_.isNil(newToken.newToken)}
                        onClick={() => {copyToken()}}
                        >{t("account.adminConsole.copy")}
                    <Icon name="copy"/>
                    </Button>} 
                />
            </Container>
            </div>
            </Segment>
         </div>
      )
      
}

NewTokenContainer.propTypes = {
    newToken: PropTypes.string,
  };

  NewTokenContainer.defaultProps = {
    newToken: _.noop,
};
export default NewTokenContainer;

